var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: "Lịch sử phiếu thu học sinh",
            size: "xl",
            "show-confirm": false,
            "cancel-text": "Đóng",
            "cancel-type": "danger",
            "use-panel": false,
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sk-panel mb-4",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "sk-panel-head",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                    width: "100%",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sk-panel-icon sk-panel-icon--warning",
                          staticStyle: { "margin-right": "15px" },
                        },
                        [_c("i", { staticClass: "el-icon-user" })]
                      ),
                      _c("div", [
                        _c("p", { staticClass: "sk-panel-title" }, [
                          _vm._v(_vm._s(_vm.studentName || "Đang tải...")),
                        ]),
                        _c("p", { staticClass: "sk-panel-subtitle" }, [
                          _vm._v("\n            Mã học sinh: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.studentCode || "—")),
                          ]),
                          _vm._v(" — Lớp/Nhóm/Gói hiện tại\n          "),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "small",
                            icon: "el-icon-download",
                            loading: _vm.isExporting,
                            disabled: _vm.tableData.length === 0,
                          },
                          on: { click: _vm.handleExportExcel },
                        },
                        [_vm._v("\n          Xuất Excel\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              staticClass: "sk-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "empty-text": "Không có lịch sử phiếu thu",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Tháng-Năm", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          "\n        " +
                            _vm._s(row.month) +
                            "/" +
                            _vm._s(row.year) +
                            "\n      "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Đợt",
                  prop: "turn",
                  width: "70",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Mã phiếu thu",
                  prop: "invoiceCode",
                  align: "center",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [_vm._v(_vm._s(row.invoiceCode || "—"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Lớp/nhóm",
                  prop: "targetName",
                  align: "center",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [_vm._v(_vm._s(row.targetName || "—"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Thiếu/Thừa phiếu thu trước",
                  align: "right",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            class:
                              row.beforeMoney < 0
                                ? "tdi-money--negative"
                                : "tdi-money--positive",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("formatCurrency")(row.beforeMoney)
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Phải thu",
                  align: "right",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          { staticClass: "tdi-money tdi-money--bold" },
                          [
                            _vm._v(
                              _vm._s(_vm._f("formatCurrency")(row.sumMoney))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Đã thu", align: "right", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "tdi-money" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrency")(row.collectedMoney))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tiền mặt",
                  align: "right",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "tdi-money" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrency")(row.cashMoney))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Chuyển khoản",
                  align: "right",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "tdi-money" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrency")(row.transferMoney))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Thiếu/Thừa còn lại",
                  align: "right",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            class:
                              row.afterMoney < 0
                                ? "tdi-money--negative"
                                : "tdi-money--positive",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("formatCurrency")(row.afterMoney)
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Trạng thái",
                  align: "center",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.status === "FULLY_PAID"
                          ? _c("span", { staticStyle: { color: "#67C23A" } }, [
                              _vm._v("Đóng đủ 100%"),
                            ])
                          : row.status === "PARTIALLY_PAID"
                          ? _c("span", { staticStyle: { color: "#E6A23C" } }, [
                              _vm._v("Chưa đóng đủ"),
                            ])
                          : row.status === "UNPAID"
                          ? _c("span", { staticStyle: { color: "#F56C6C" } }, [
                              _vm._v("Chưa đóng 100%"),
                            ])
                          : row.status === "UNBILLED"
                          ? _c("span", [_vm._v("Chưa có phiếu thu")])
                          : row.status === "OVERPAID"
                          ? _c("span", [_vm._v("Đóng thừa")])
                          : row.status === "FULLY_PAID_WITH_SURPLUS"
                          ? _c("span", { staticStyle: { color: "#67C23A" } }, [
                              _vm._v("Đóng đủ thừa"),
                            ])
                          : row.status === "PAID_WITH_DEFICIT"
                          ? _c("span", { staticStyle: { color: "#E6A23C" } }, [
                              _vm._v("Đóng đủ thiếu"),
                            ])
                          : _c("span", [_vm._v(_vm._s(row.status))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "180",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Chi tiết phiếu thu",
                              placement: "top",
                              enterable: false,
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "info",
                                icon: "el-icon-document",
                                "aria-label": "Chi tiết phiếu thu",
                                circle: "",
                                disabled: !row.idx,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleInvoiceDetail(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Xuất excel",
                              placement: "top",
                              enterable: false,
                            },
                          },
                          [
                            _vm.checkPermission(["tuition_excel_export_v4"])
                              ? _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "success",
                                    icon: "el-icon-download",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleExportRowExcel(row)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Thanh toán",
                              placement: "top",
                              enterable: false,
                            },
                          },
                          [
                            _vm.checkPermission(["tuition_payment_v4"])
                              ? _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-wallet",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePayment(row)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Xoá phiếu thu lớp/nhóm cũ",
                              placement: "top",
                              enterable: false,
                            },
                          },
                          [
                            _vm.checkPermission([
                              "tuition_fees_services_action_v4",
                            ]) && _vm.isDeletable(row)
                              ? _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    circle: "",
                                    loading: _vm.deletingIdx === row.idx,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDeleteOldInvoice(row)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("invoice-revenue-detail-dialog", {
        ref: "invoiceRevenueDetailDialog",
        on: { saved: _vm.handleInvoiceDetailSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }